import { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { getLineOfWork } from "../../services/roleService";

const useListLineOfWork = () => {
  const [data, setData] = useState([]);
  const [lineOfWorkList, setLineOfWorkList] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getLineOfWork();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);

      const mapValue = objectValue.map((data) => {
        return {
          ...data,
          value: data.nameTh,
        };
      });

      setLineOfWorkList(mapValue);
    }
  }, [setData, setLineOfWorkList]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, lineOfWorkList];
};

export default useListLineOfWork;
